import { MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface YimTalkBrandTitleProps {
  className?: string;
}

/** "YIM T" + chat icon + "lk" (replaces the "a" in Talk). */
export function YimTalkBrandTitle({ className }: YimTalkBrandTitleProps) {
  return (
    <span className={cn('inline-flex items-center gap-0', className)}>
      <span>YIM T</span>
      <MessageCircle
        className="mx-0.5 h-[0.68em] w-[0.68em] shrink-0 text-accent-300"
        strokeWidth={2}
        aria-hidden
      />
      <span>lk</span>
    </span>
  );
}
